let constants = {
    SUCCESS: 200,
    ACTIVE: "Active",
    INACTIVE: "Inactive",
    ADD: "Add",
    EDIT: "Edit",
    CONTAINS: "Contains",

    CONFIRMATION_BOX_CONFIG: {
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        reverseButtons: true,
        showCloseButton: true,
        customClass: "swal-confirmation",
        width: '450px',
        padding: '20px'
    },

    MENUS: {
        "Admin": {
            "Menus": [
                { "SubMenu": "Role and Authorization Master", "Path": "/admin/role-master" },
                { "SubMenu": "User Master", "Path": "/admin/user-master" },
            ]
        },
        "Reopen Closed Records": {
            "Menus": [
                { "SubMenu": "Litigation", "Path": "/access-control/litigation" },
                { "SubMenu": "Notices", "Path": "/access-control/notices" },
            ]
        },
        "Masters": {
            "Menus": [
                { "SubMenu": "Court Master", "Path": "/master/court-master" },
                { "SubMenu": "Party Master", "Path": "/master/party-master" },
                { "SubMenu": "Zone Master", "Path": "/master/zone-master" },
                { "SubMenu": "Division Master", "Path": "/master/division-master" },
                { "SubMenu": "Branch Master", "Path": "/master/branch-master" },
                { "SubMenu": "Application Status Master", "Path": "/master/application-status-master" },
                { "SubMenu": "Documents With Master", "Path": "/master/documents-with-master" },
                { "SubMenu": "Act Master", "Path": "/master/act-master" },
                { "SubMenu": "Department Master", "Path": "/master/department-master" },
                { "SubMenu": "Suit Filed Master", "Path": "/master/suit-filed-master" },
                { "SubMenu": "IF Pending Location Master", "Path": "/master/if-pending-location-master" },
                { "SubMenu": "Issuing Authority Master", "Path": "/master/issuing-authority-master" },
                { "SubMenu": "Control Master", "Path": "/master/control-master" },
                { "SubMenu": "Category Master", "Path": "/master/category-master" },
            ]
        },
        "Transactions": {
            "Menus": [
                { "SubMenu": "Litigation", "Path": "/transactions/litigation" },
                { "SubMenu": "Notices", "Path": "/transactions/notices" },
                { "SubMenu": "Agreements", "Path": "/transactions/agreements" },
                { "SubMenu": "Power of Attorney", "Path": "/transactions/power-of-attorney" },
                { "SubMenu": "Out of Court Settlements", "Path": "/transactions/settlements" },
                { "SubMenu": "Intellectual Property Rights", "Path": "/transactions/intellectual-property-rights" }
            ]
        },
        "Reports": {
            "Menus": [
                { "SubMenu": "Litigation", "Path": "/reports/litigation" },
                { "SubMenu": "Notices", "Path": "/reports/notices" },
                { "SubMenu": "Agreements", "Path": "/reports/agreements" },
                { "SubMenu": "Power of Attorney", "Path": "/reports/power-of-attorney" },
                { "SubMenu": "Litigation Report", "Path": "/reports/litigation-summary-report" },
                { "SubMenu": "Amounts Summary", "Path": "/reports/amounts-summary" },
                { "SubMenu": "Certificate", "Path": "/reports/certificate" },
                { "SubMenu": "IPR Report", "Path": "/reports/ipr" }
            ]
        },
        "Help": {
            "Menus": [
                { "SubMenu": "Master", "Path": "/help/master" },
                { "SubMenu": "Litigation", "Path": "/help/litigation" },
                { "SubMenu": "Notices", "Path": "/help/notices" },
                { "SubMenu": "Agreements", "Path": "/help/agreements" },
                { "SubMenu": "Power of Attorney", "Path": "/help/power-of-attorney" },
                { "SubMenu": "Queries", "Path": "/help/queries" },
            ]
        },
    },

    LOGOUTCONFIRM: "Are you sure you want to LogOut?",

    ALERT_PARAMS: {
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        reverseButtons: true,
        showCloseButton: true,
        customClass: "swal-confirmation",
    }

}

module.exports = Object.freeze(constants);
